import { render } from "./ErrorModal.vue?vue&type=template&id=1ab78dbc"
import script from "./ErrorModal.vue?vue&type=script&lang=js"
export * from "./ErrorModal.vue?vue&type=script&lang=js"

import "./ErrorModal.vue?vue&type=style&index=0&id=1ab78dbc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__